<template>
  <div class="menu-wrap">
    <div class="menu">
      <div class="footer">
        <div class="footer-left clickable">
          <div class="footer-btn " @click="ToggleAudio">
            <div class="audio-btn"></div>
          </div>
          <img class="footer-btn" src="/images/ui/share_btn.png" />
        </div>
        <div class="">
          <img class="footer-logo" src="/images/ui/rs_logo.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "Menu",
  data: function () {
    return {
      currentUrl: "",
    };
  },
  created() {},
  methods: {
    ToggleAudio() {
      var audio = document.querySelector("audio");

      if ($(".audio-btn").hasClass("audio-off")) {
        //play audio
        $(".audio-btn").removeClass("audio-off");
        audio.play();
      } else {
        //pause audio
        $(".audio-btn").addClass("audio-off");
        audio.pause();
      }
    },
  },
};
</script>

<style lang="scss">
</style>
